import { render } from "./FileIcon.vue?vue&type=template&id=13a91e3f&scoped=true"
import script from "./FileIcon.vue?vue&type=script&lang=js"
export * from "./FileIcon.vue?vue&type=script&lang=js"

import "./FileIcon.vue?vue&type=style&index=0&id=13a91e3f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a91e3f"]])

export default __exports__